import { Box, Center, Wrap, WrapItem } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoryCard from "../components/CategoryCard";
import { getCategories } from "../redux/actions/categoryActions";

const CategoriesScreen = () => {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.category);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  return (
    <>
      {" "}
      {categories.length > 1 && (
        <Box>
          <Wrap spacing='30px' justify='center' minHeight='80vh' mx={{ base: "12", md: "20", lg: "32" }}>
            {/* <ProductCard product={data[0]} loading={false} /> */}
            {categories.map((category) => (
              <WrapItem key={category.CAT_ID}>
                <Center w='350px' h='250px'>
                  <CategoryCard category={category} loading={false} />
                </Center>
              </WrapItem>
            ))}
          </Wrap>
        </Box>
      )}
    </>
  );
};

export default CategoriesScreen;
